//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Object.js";
import "../PcbExchange/PcbExchange.Manager.js";
let d=[[],[[["fileName"],"ExportDesignRules",{},1,0],[["fileName"],"ImportDesignRules",{},1,0]],[]];
SPLM.PcbExchange.DesignRuleManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PcbExchange.DesignRuleManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;